export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const MAKE_INITIALIZED = 'MAKE_INITIALIZED';
export const MAKE_NON_INITIALIZED = 'MAKE_NON_INITIALIZED';
export const TOGGLE_MENU_DRAWER = 'TOGGLE_MENU_DRAWER';
export const SHOW_TEMPORARY_TOOLTIP = 'SHOW_SIMPLE_INFORMER';
export const HIDE_TEMPORARY_TOOLTIP = 'HIDE_SIMPLE_INFORMER';
export const CHANGE_TABS_STATE = 'CHANGE_TABS_STATE';
